const formatPrice = (value, isCentAmount = true) => {
  const amount = isCentAmount ? value / 100 : value;
  const price = !isNaN(amount) ? amount.toFixed(2).toString() : "0.00";
  if (price === "0") {
    return "0.00";
  }
  return price;
};
export {
  formatPrice
};
//# sourceMappingURL=format-price.js.map
